export const QA_NAME_VIEWING_PROFILE_DOCUMENTS_RETRY = 'viewingDocumentsRetry'

export const QA_NAME_VIEWING_PROFILE_DOCUMENTS_TABLE = 'viewingDocuments'

export const QA_NAME_VIEWING_PROFILE_DOCUMENTS_UPLOAD = 'viewingDocumentsUpload'

export const VIEWING_DOCUMENT_UPLOAD_ACTION_NAME = 'uploadViewingDocument'

export const VIEWING_PROFILE_DOCUMENTS_SKELETON_ROWS = 3

export const VIEWING_DOCUMENTS_PAGE_SIZE = 20

export const VIEWING_DOCUMENT_COLUMN_NAME = {
  Name: 'name',
  Size: 'size_bytes',
  Uploaded: 'uploaded_at',
  UploadedBy: 'uploaded_by',
}

export const VIEWING_DOCUMENT_COLUMNS_CONFIG = {
  [VIEWING_DOCUMENT_COLUMN_NAME.Name]: {
    index: 0,
    name: VIEWING_DOCUMENT_COLUMN_NAME.Name,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsNameColumnKey',
    visible: true,
    width: 300,
  },
  [VIEWING_DOCUMENT_COLUMN_NAME.Size]: {
    index: 1,
    name: VIEWING_DOCUMENT_COLUMN_NAME.Size,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsSizeColumnKey',
    visible: true,
    width: 110,
  },
  [VIEWING_DOCUMENT_COLUMN_NAME.Uploaded]: {
    index: 2,
    name: VIEWING_DOCUMENT_COLUMN_NAME.Uploaded,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedColumnKey',
    visible: true,
    width: 180,
  },
  [VIEWING_DOCUMENT_COLUMN_NAME.UploadedBy]: {
    index: 3,
    name: VIEWING_DOCUMENT_COLUMN_NAME.UploadedBy,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedByColumnKey',
    visible: true,
    width: 240,
  },
}

export const VIEWING_DOCUMENTS_STATE = {
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  table: 'table',
}
